export const getVerificationError = (state) => state.auth.emailVerification.verificationError;
export const getCanResend = (state) => state.auth.emailVerification.canResend;
